<template>
    <div class="detail-page">
        <cms-generic-placeholder v-bind="mainContent"/>
    </div>

</template>

<script>
    import { mapState } from 'vuex';
    import { MAIN } from 'constants/placeholders-ids';
    import CmsGenericPlaceholder from 'framework/components/cms/cms-generic-placeholder/cms-generic-placeholder';

    export default {
        components: { CmsGenericPlaceholder },
        computed: {
            ...mapState('page', ['containers']),
            mainContent() {
                return this.containers[MAIN];
            },
        },
    };
</script>
